export default __webpack_public_path__ + "static/media/sh-ac.d011a7a0.svg";